import { NotificationDataBuilder } from '../notifications-classes'

export class FallBackNotification extends NotificationDataBuilder {
  constructor(props) {
    super(props)
  }
  setOnClick(onClick) {
    this.onClick = onClick
  }
}
